import axios from 'axios';
import { getAuthToken } from './storageUtil';

// Create an axios instance
const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_API_URL,  // Base URL for your API
    headers: {
        'Content-Type': 'application/json',
    },
});

// Add a request interceptor (optional, for adding auth token or custom headers)
axiosInstance.interceptors.request.use(
    (config) => {
        // You can access the localStorage for auth tokens or other global settings here
        const token = getAuthToken();
        if (token) {
            // Attach the token to each request (e.g., for Bearer authentication)
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        // Handle request errors
        return Promise.reject(error);
    }
);

// Add a response interceptor (optional, for handling global responses)
axiosInstance.interceptors.response.use(
    (response) => {
        // Optionally handle the response data globally (e.g., logging or transformation)
        return response;
    },
    (error) => {
        // Global error handling (e.g., handling 401 errors)
        if (error.response?.status === 401) {
            // Redirect to login page if unauthorized (for example)
            window.location.href = '/login';

            // Do NOT reject after triggering the redirect. The document is
            // already navigating away, so no caller can usefully handle this,
            // but the rejection still propagates — and because the callers are
            // fire-and-forget effects with no .catch(), it surfaced as an
            // unhandled rejection and Create React App's red error overlay.
            //
            // A promise that never settles stops the caller's continuation from
            // running against a half-torn-down page and produces no rejection.
            // It is not a leak in practice: the document unloads moments later.
            return new Promise(() => { });
        }

        // Handle 400 errors explicitly
        if (error.response?.status === 400) {
            // Handle 400 error (perhaps show a custom error message to the user)
            console.warn('Bad Request (400):', error.response.data);
            // Optionally, you can return the error data instead of rejecting it
            return Promise.resolve(error.response);  // Prevent it from entering .catch
        }

        return Promise.reject(error);
    }
);

export default axiosInstance;
